import type { Salarie } from '../types/ndf';

/**
 * Les champs que le formulaire de fiche salarié a le droit d'envoyer.
 *
 * Liste POSITIVE, et non une liste d'exclusions : le serveur refuse toute clé
 * qu'il ne connaît pas, et une fiche relue porte aussi son identifiant, ses
 * horodatages et ses valeurs calculées (ancienneté, caractère indicatif de la
 * période d'essai). Énumérer ce qu'on exclut oblige à penser à chaque nouveau
 * champ calculé ; énumérer ce qu'on autorise les écarte tous par défaut.
 *
 * ELLE VIT DANS SON PROPRE FICHIER pour être LUE par le test
 * `scripts/test-ndf-validation.ts`, qui vérifie que chaque champ autorisé ici
 * existe bien dans le schéma Zod du serveur. Le test en gardait auparavant une
 * COPIE : l'écran a retiré `actif` — le statut de compte a désormais sa propre
 * action — la copie ne l'a pas suivi, et la suite est restée rouge. Un test
 * durablement rouge n'est plus lu, donc ne protège plus rien.
 */
export const CHAMPS_MODIFIABLES = [
  'civilite', 'prenom', 'nom', 'matricule', 'email', 'fonction',
  'num_secu', 'date_naissance', 'lieu_naissance',
  'adresse_rue', 'adresse_cp', 'adresse_ville', 'portable',
  'date_debut_contrat', 'type_contrat', 'statut_rh',
  'fin_periode_essai_1', 'fin_periode_essai_2',
  'date_fin_contrat', 'motif_depart',
  'responsable_rh_id',
  'zoho_vendor_id', 'beneficiaire_id',
  'avance_frais', 'avance_montant', 'avance_date', 'avance_recuperee_stc',
  'cumul_ik_initial_km', 'cumul_ik_initial_annee',
  // Module Congés (R-SAL-10/11, D3.6).
  'modalite_temps_travail', 'cumul_absences_autorisees', 'beneficie_conges',
  // `statut_compte` n'est PAS ici : ouvrir ou fermer un accès passe par sa
  // propre action, avec sa machine à états et son audit.
] as const satisfies ReadonlyArray<keyof Salarie>;

/** Ne garde d'une fiche que ce que le serveur accepte de recevoir. */
export function corpsModifiable(f: Partial<Salarie>): Partial<Salarie> {
  const corps: Partial<Salarie> = {};
  for (const cle of CHAMPS_MODIFIABLES) {
    if (cle in f) (corps as Record<string, unknown>)[cle] = (f as Record<string, unknown>)[cle];
  }
  return corps;
}
